import { buildSignatureReceipt } from './signatureReceipt';

const params = new Map(window.location.search.slice(1).split('&').map(kv => kv.split('=')));
let origin = decodeURIComponent(params.get("origin"));

function sendToVend(vendStep, pollingResponse) {
    let message;
    if (pollingResponse) {
        message = JSON.stringify({
            "step": vendStep,
            "receipt_html_extra": buildSignatureReceipt(pollingResponse)
        });
    }
    else {
        message = JSON.stringify({
            "step": vendStep
        });
    }

    window.parent.postMessage(message, origin || "https://storekitdemo.vendhq.com");
}

export default sendToVend;